"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var react_acdc_1 = require("@seaweb/react-acdc");
var useForkRef_1 = __importDefault(require("@seaweb/coral/hooks/useForkRef"));
var color_1 = require("@seaweb/coral/utils/color");
var useWrapEvent_1 = __importDefault(require("@seaweb/coral/hooks/useWrapEvent"));
var childrenWithIndex_1 = __importDefault(require("@seaweb/coral/utils/childrenWithIndex"));
var SelectScroller_1 = __importDefault(require("./SelectScroller"));
var SelectContext_1 = require("./SelectContext");
exports.EmptyPlaceholder = styled_1.default.div.attrs({
    'data-coral-select-list-empty': '',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ", "\n"], ["\n  width: 100%;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", "px;\n    font-family: ", ";\n    color: ", ";\n  "], ["\n    font-size: ", "px;\n    font-family: ", ";\n    color: ", ";\n  "])), theme.typography.sizes.main, theme.typography.main, color_1.alp(theme.colors.alternate, 0.5));
});
var SelectList = react_1.forwardRef(function SelectList(_a, ref) {
    var as = _a.as, children = _a.children, _b = _a.emptyPlaceholder, emptyPlaceholder = _b === void 0 ? 'No Data' : _b, onBlur = _a.onBlur, onKeyDown = _a.onKeyDown, props = __rest(_a, ["as", "children", "emptyPlaceholder", "onBlur", "onKeyDown"]);
    var _c = __read(react_acdc_1.useAcdcScrollerProps(), 1), _d = _c[0], scrollerRef = _d.ref, acdcBlur = _d.onBlur, acdcKeyDown = _d.onKeyDown, scrollerProps = __rest(_d, ["ref", "onBlur", "onKeyDown"]);
    var handleBlur = useWrapEvent_1.default(onBlur, acdcBlur);
    var handleKeyDown = useWrapEvent_1.default(onKeyDown, acdcKeyDown);
    var handleRef = useForkRef_1.default(ref, scrollerRef);
    return (react_1.default.createElement(SelectContext_1.SelectListContext.Provider, { value: { emptyPlaceholder: emptyPlaceholder } },
        react_1.default.createElement(SelectScroller_1.default, __assign({ as: as, ref: handleRef, onBlur: handleBlur, onKeyDown: handleKeyDown }, scrollerProps, props), emptyPlaceholder !== null && !react_1.Children.toArray(children).filter(Boolean).length ? (react_1.default.createElement(exports.EmptyPlaceholder, null, emptyPlaceholder)) : (childrenWithIndex_1.default(children)))));
});
exports.default = react_1.memo(SelectList);
var templateObject_1, templateObject_2;
